import React from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {addIngredient} from "../../actions/updateFirestoreData/userData/addIngredient"
import {getIngredients} from "../../actions/getFirestoreData/getIngredients"
import {dailyDish} from "../../actions/getFirestoreData/dailyDish";
import {getRecipesByIngredient} from '../../actions/getFirestoreData/getRecipesByIngredient'
import {numAverage} from "../../actions/calcul/average";
import RecipeCard from "../../components/searchRecipe/RecipeCard";
import IngredientsTable from "../../components/searchRecipe/IngredientsTable";
import {Typography, Grid, CircularProgress} from "@material-ui/core";


/**
 * This class wil be the main page of our app, where we present lot of recipe
 * (daily dishes, list of all ingredients available and recipes depending on your ingredients list)
 */
class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            dailyRecipes: [],
            ingredients: [],
            myRecipes: [],
            allIngredients: [],
            isLoading: true,
            loadingIngredients: true,
            isLoadingMyFavorite: true
        };
    }

    _isMounted = false;

    componentDidMount = async () => {
        this._isMounted = true;
        const dailyRecipesTab = await this.props.dailyDish() //array containing daily dishes
        //if receive tab change in tabbbbbbb
        let allIngredients = await this.props.getIngredients();
        // we will show only ingredients not in user's ingredients  list

        allIngredients = allIngredients.filter(ingredient => !this.props.auth.ingredients.includes(ingredient))
        const myRecipes = await this.props.getRecipesByIngredient(this.props.auth.ingredients)
        if (this._isMounted) {
            this.setState({
                dailyRecipes: dailyRecipesTab,
                loading: false,
                allIngredients,
                myRecipes,
                isLoadingMyFavorite: false,
                loadingIngredients: false
            })
        }
    };

    componentWillUnmount = () => {
        console.log("fin de mount");
        this._isMounted = false;
    };

    render() {

        const {loading, isLoadingMyFavorite, dailyRecipes, loadingIngredients, ingredients, myRecipes, allIngredients} = this.state
        return (
            <Grid container justify='center'>
                {console.log("re render")}

                <Grid container justify='center' spacing={2} style={{margin: 20}}>
                    <Grid item>
                        <Typography> RECETTES DU JOUR 🍜</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justify='center' spacing={2}>
                            {loading ? <CircularProgress/> :
                                dailyRecipes.map(recipe => (
                                    <Grid item  key={recipe.name}>
                                        <RecipeCard  recipe={recipe}/>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>

                    <IngredientsTable/>
                    <Grid item xs={12}>
                        <Grid container justify='center' spacing={2}>
                            {isLoadingMyFavorite ? <CircularProgress/> :
                                myRecipes.map(recipe => (
                                    <RecipeCard recipe={recipe}/>
                                ))
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = ({auth}) => {
    return {auth}
};

export default withRouter(connect(
    mapStateToProps,
    {
        dailyDish,
        numAverage,
        getIngredients,
        addIngredient,
        getRecipesByIngredient,
    }
)(withRouter(Dashboard)))
